import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { IMilker } from 'models/MilkingProcess'
import MilkingProcessService from 'services/milkingProcessService'

export const useGetMilkersInfo = () => {
	const { data, refetch, isError, isLoading } = useQuery<IMilker[], AxiosError>(
		{
			queryKey: ['milkers-info'],
			queryFn: async () => {
				const response = await MilkingProcessService.getMilkersInfo()
				return response
			},
			staleTime: 50000,
			retry: 3,
		},
	)

	return {
		data,
		isLoading,
		isError,
		refetch,
	}
}
